module.exports = __webpack_public_path__ + "img/mail_outline.e2ab348b.svg";